export default {
    inserted: function(el) {
        // TODO: Prevent duplicate usage on the same view
        el.focus();
    }
};
